import styles from './index.module.scss'
import ProjectCard, { SkeletonCard } from './ProjectCard'
import { useRef, useEffect, useState } from 'react'
import { PROJECT_IS_INTERSECTING } from '../../constants'
export default function ProjectList({ layoutType, loading, projectReportInfoList, containerLayout }: {
    layoutType: string,
    projectReportInfoList?: ProjectReportInfo[],
    loading: boolean,
    containerLayout: {
        width: number,
        height: number,
    }
}) {
    const layoutMap: any = {
        '1x': {
            width: '100%', height: '100%'
        },
        '2x': {
            width: '49.75%', height: '50%'
        },
        '3x': {
            width: '33%', height: '50%',
        }
    }
    const layout = layoutMap[layoutType];
    const containerRef = useRef<HTMLDivElement>(null);
    const intersectionOberverRef = useRef<IntersectionObserver>();
    useEffect(() => {
        if (containerRef.current) {
            const intersectionOberver = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            window.dispatchEvent(new CustomEvent(PROJECT_IS_INTERSECTING, {
                                detail: entry.target
                            }))
                        }
                    });
                },
                {
                    threshold: 0,
                }
            );
            intersectionOberverRef.current = intersectionOberver;
        }
    }, []);
    const onProjectMounted = (ele: HTMLDivElement) => {
        if (intersectionOberverRef.current) {
            intersectionOberverRef.current.observe(ele);
        }
    }
    const [refreshKey, setRefreshKey] = useState(0)
    useEffect(() => {
        setRefreshKey(new Date().getTime())
    }, [layoutType])
    return (
        <section ref={containerRef} key={refreshKey} className={styles.list} style={{
            ...containerLayout
        }}>
            {
                loading ? [1, 2, 3, 4, 5, 6].map(i => {
                    return <SkeletonCard  {...layout} key={i} />
                }) :
                    projectReportInfoList?.length === 0 ? <h1>暂无展会</h1> :
                    projectReportInfoList
                    ?.filter(p => p.project.name !== "系统测试")
                    .map(p => (
                      <ProjectCard
                        onProjectMounted={onProjectMounted}
                        {...layout}
                        key={p.project.projectId}
                        project={p}
                      />
                    ))
            }
        </section>
    )
}